import './css.js';

async function init() {
    await import('../../assets/unify/plugins/back-to-top.js');
    await import('../../assets/unify/plugins/smoothScroll.js');
    await import('../../assets/unify/plugins/jquery.parallax.js');
    await import('../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel.js');

    let countryList = {};
    let defaultCountry;
    switch (locale) {
        case 'en':
            countryList = await import('umpirsky/country-list/data/en/country.json');
            defaultCountry = 'US';
            break;
        case 'ja':
            countryList = await import('umpirsky/country-list/data/ja/country.json');
            defaultCountry = 'JP';
            break;
        case 'zh-CN':
            countryList = await import('umpirsky/country-list/data/zh_CN/country.json');
            defaultCountry = 'CN';
            break;
        case 'ko':
            countryList = await import('umpirsky/country-list/data/ko/country.json');
            defaultCountry = 'KO';
            break;
        default:
            countryList = await import('umpirsky/country-list/data/zh_Hant_TW/country.json');
            defaultCountry = 'TW';
    }

    let App = await import('../../assets/unify/js/app.js');
    let OwlCarousel = await import('../../assets/unify/js/plugins/owl-carousel.js');
    $(document).ready(function () {
        App.init();
        App.initParallaxBg();
        OwlCarousel.initOwlCarousel();
    });

    (function ($) {
        let countryList$ = $('#signup-country');
        for (let country in countryList) {
            if (country !== defaultCountry) {
                countryList$.append($('<option>', {
                    value: country
                }).text(countryList[country]));
            }
            else {
                countryList$.append($('<option>', {
                    value: country,
                    selected: true
                }).text(countryList[country]));
            }
        }
    })(jQuery);
}

init().then(async function () {
    let parsley = await import('parsleyjs');
    await import('parsleyjs/dist/i18n/' + locale.replace('-', '_').toLowerCase());
    let moment = await import('moment');
    let text = await import('../../public/locales/'+locale+'/hotel.json');

    $('#signup-username').attr('data-parsley-required', true);
    $('#signup-password').attr({
        'data-parsley-required': true,
        'data-parsley-minlength': '8',
        'data-parsley-pattern': '(^[0-9]+[A-Za-z]+|^[A-Za-z]+[0-9]+)[A-Za-z0-9]*',
        'data-parsley-pattern-message': text.SystemText.AtLeast
    });
    $('#signup-repeat-password').attr({
        'data-parsley-required': true,
        'data-parsley-equalto': '#signup-password'
    });
    $('#signup-name').attr({
        'data-parsley-required': true,
        'data-parsley-minlength': 2,
        'data-parsley-whitespace': 'trim'
    });
    $('input[name="gender"]').attr('data-parsley-required', function () {
        return this.required;
    });
    $('#signup-id').attr('data-parsley-required', function () {
        return this.required;
    }).attr({
        'data-parsley-type': 'alphanum',
        'data-parsley-minlength': 7
    });
    $('#signup-country').attr('data-parsley-required', function () {
        return this.required;
    });
    $('#signup-birthday-year').attr({
        'data-parsley-required': true,
        'data-parsley-range': '[1900, ' + moment().get('year') + ']',
        'data-parsley-group': 'birthday'
    });
    $('#signup-birthday-month').attr({
        'data-parsley-required': true,
        'data-parsley-range': '[1, 12]',
        'data-parsley-group': 'birthday'
    });
    $('#signup-birthday-day').attr({
        'data-parsley-required': true,
        'data-parsley-range': '[1, 31]'
    });
    $('#signup-phone').attr('data-parsley-required', function () {
        return this.required;
    }).attr({
        'data-parsley-type': 'number'
    });
    $('#signup-cellphone').attr('data-parsley-required', function () {
        return this.required;
    }).attr({
        'data-parsley-type': 'number'
    });
    $('#signup-thsr-cellphone').attr('data-parsley-required', function () {
        return this.required;
    }).attr({
        'data-parsley-type': 'number',
        'data-parsley-error-message': "如您加購高鐵聯票，手機號碼請勿超過10碼"
    });
    $('#signup-zip-code').attr('data-parsley-required', function () {
        return this.required;
    }).attr({
        'data-parsley-type': 'number',
        'data-parsley-length': '[3, 6]'
    });
    $('#signup-address').attr('data-parsley-required', function () {
        return this.required;
    });
    $('#signup-email').attr({
        'data-parsley-required': true,
        'data-parsley-type': 'email'
    });

    let validator = parsley.$element.find('#signup-form').parsley({
        errorsWrapper: '<div></div>',
        errorTemplate: '<span class="color-red"></span>',
        errorsContainer: function (field) {
            return field.$element.closest('td').find('div.error-message');
        }
    });

    $('#signup-birthday-year, #signup-birthday-month').change(function () {
        if (validator.isValid('birthday')) {
            let year = $('#signup-birthday-year').val();
            let month = $('#signup-birthday-month').val();
            let validDay = moment().year(year).month(month - 1).endOf('month');
            let isDST = validDay.isDST();
            if (isDST === true) {
                let offset = validDay.utcOffset();
                if (offset < 0) {
                    validDay.utcOffset(offset + 60);
                } else {
                    validDay.utcOffset(offset - 60);
                }
            }
            $('#signup-birthday-day').attr('data-parsley-range', '[1, '+ validDay.date() + ']');
        }
    });

    $('#signup-submit').click(function () {
        validator.validate();

        if (validator.isValid()) {
            $('#signup-form').submit();
        }
    });

    $('#signup-reset').click(function () {
        validator.reset();
    });
});


// WEBPACK FOOTER //
// ./webpack/signup/entry.js